export const pagesDevicesDeviceGroupsEn = {
  detail: {
    header: {
      breadcrumb: 'Device Groups',
      deleteDialog: {
        cancel: 'Cancel',
        confirm: 'Delete',
        description: 'This device group will be permanently deleted. This action cannot be undone.',
        title: 'Delete {{name}}?'
      },
      edit: 'Edit',
      title: 'Device Group'
    }
  },
  list: {
    createButton: 'Create Device Group',
    description: 'Manage device groups for configuring rules & policies and more.',
    pageTitle: 'Device Groups',
    searchPlaceholder: 'Search device groups...',
    title: 'Device Groups'
  },
  title: 'Groups',
  wizard: {
    basicForm: {
      duplicateName: 'A device group with this name already exists.',
      intendedUse: 'Intended use',
      intendedUsePlaceholder: 'Describe how this group will be used',
      name: 'Name',
      namePlaceholder: 'Enter device group name',
      optional: '(Optional)'
    },
    completeDialog: {
      createMessage: 'Device group created successfully.',
      detailLink: 'View device group',
      listLink: 'Back to device groups',
      updateMessage: 'Device group updated successfully.'
    },
    genreRulesStep: {
      genreRulesSection: 'Condition',
      individualSection: 'Individual',
      noTypeSelected: 'No condition or individual selection has been set.'
    },
    navigation: {
      basic: 'Basic',
      confirm: 'Group Confirmation',
      setGenreRules: 'Group Definition',
      titleCreate: 'Create Device Group',
      titleEdit: 'Edit Device Group'
    },
    stepTitle: {
      basic: '1. Basic',
      confirm: '3. Group Confirmation',
      setGenreRules: '2. Group Definition'
    }
  }
};